import { Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';

import { RecuContext, RegieContext } from '@/contexts';
import {
  LoadingContextProvider,
  ModeReglementContextProvider,
  RecuContextProvider,
} from '../Context';
import { ModalRecu } from '../Encaissement/ModalRecu';
import RecusListe from '../Encaissement/RecusListe/RecusListe';

/**
 * Composant servant pour le points de menu "Liste des reçus"
 */
const RecusMenu = () => {
  const [modalRecu, setModalRecu] = React.useState<number | null>();

  const { regies, selectedRegie } = React.useContext(RegieContext);

  const hasRecuParMail = React.useMemo(
    () => _.find(regies, { identifiant: selectedRegie })?.envoiRecuParMail || false,
    [selectedRegie, regies],
  );

  const handleOpenRecu = React.useCallback((id: number) => {
    setModalRecu(id);
    toast.dismiss();
  }, []);

  return (
    <Segment basic secondary style={{ margin: 0, height: '100%' }}>
      <Segment style={{ height: '100%', overflow: 'hidden' }} id="factures-recus">
        <LoadingContextProvider>
          <ModeReglementContextProvider autoload="régie">
            <RecuContextProvider defaultFilteredOnRegisseur={false}>
              <RecuContext.Consumer>
                {({ recus }) => (
                  <>
                    <RecusListe
                      standAlone
                      onOpen={handleOpenRecu}
                      defaultFilteredOnRegisseur={false}
                    />
                    {!_.isNil(modalRecu) && (
                      <ModalRecu
                        envoiRecuParMail={hasRecuParMail}
                        recu={_.find(recus, { identifiant: modalRecu })}
                        onClose={() => {
                          setModalRecu(null);
                        }}
                      />
                    )}
                  </>
                )}
              </RecuContext.Consumer>
            </RecuContextProvider>
          </ModeReglementContextProvider>
        </LoadingContextProvider>
      </Segment>
    </Segment>
  );
};

export default RecusMenu;
